export const InputBase_v2 = {
	name: 'InputBase_v2',
	inheritAttrs: false,
	props: {
		type: String,
		label: String,
		defaultValue: String,
		value: {
			type: [String, Number, Boolean],
			default: null,
		},
		errorMessage: String,
		disabled: Boolean,
		required: Boolean,
		readonly: Boolean,
		helpMessage: String,
	},
	data: () => ({
		error: false,
	}),
	computed: {
		tag: (vm) => vm.type === 'textarea' ? 'textarea' : 'input',
	},
	methods: {
		checkValidity: function() {
			if (this.$refs.input.checkValidity())
				this.error = false;
		},
	},
	render(h) {
		return (
			<div class="input-block">
				<this.tag
					ref="input"
					class="input-block__input"
					attrs={ this.$attrs }
					type={ this.type !== 'textarea' ? this.type : null }
					domPropsRequired={ this.required }
					domPropsReadOnly={ this.readonly }
					domPropsDisabled={ this.disabled }
					domPropsValue={ this.value }
					vOn:blur={ () => {
						this.$forceUpdate();
						this.$nextTick(() => this.checkValidity());
					}}
					vOn:input={ (event) => this.$emit('input', event.currentTarget.value, event) }
					vOn:change={ () => this.checkValidity() }
					vOn:invalid={ () => this.error = true }
				/>
				{ this.label ? (
					<label class="label input-block__label">
						{ this.label }
					</label>
				) : null }
				{ (this.helpMessage || this.error && this.errorMessage) ? (
					<div class={{
						'form-text': true,
						'text-danger': this.error,
					}}>
						<small>{ this.helpMessage || this.errorMessage }</small>
					</div>
				) : null }
			</div>
		);
	}
}
